'use client';

import _slicedToArray from "/codebuild/output/src1305/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { getPrimaryShade } from '../get-primary-shade/get-primary-shade.mjs';
import { isLightColor } from '../luminance/luminance.mjs';
function parseThemeColor(_ref) {
  var color = _ref.color,
    theme = _ref.theme,
    colorScheme = _ref.colorScheme;
  if (typeof color !== "string") {
    throw new Error("[@mantine/core] Failed to parse color. Expected color to be a string, instead got ".concat(typeof color));
  }
  if (color === "bright") {
    return {
      color: color,
      value: colorScheme === "dark" ? theme.white : theme.black,
      shade: void 0,
      isThemeColor: false,
      isLight: isLightColor(colorScheme === "dark" ? theme.white : theme.black, theme.luminanceThreshold),
      variable: "--mantine-color-bright"
    };
  }
  if (color === "dimmed") {
    return {
      color: color,
      value: colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
      shade: void 0,
      isThemeColor: false,
      isLight: isLightColor(colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6], theme.luminanceThreshold),
      variable: "--mantine-color-dimmed"
    };
  }
  if (color === "white" || color === "black") {
    return {
      color: color,
      value: color === "white" ? theme.white : theme.black,
      shade: void 0,
      isThemeColor: false,
      isLight: isLightColor(color === "white" ? theme.white : theme.black, theme.luminanceThreshold),
      variable: "--mantine-color-".concat(color)
    };
  }
  var _color$split = color.split("."),
    _color$split2 = _slicedToArray(_color$split, 2),
    _color = _color$split2[0],
    shade = _color$split2[1];
  var colorShade = shade ? Number(shade) : void 0;
  var isThemeColor = (_color in theme.colors);
  if (isThemeColor) {
    var colorValue = colorShade !== void 0 ? theme.colors[_color][colorShade] : theme.colors[_color][getPrimaryShade(theme, colorScheme || "light")];
    return {
      color: _color,
      value: colorValue,
      shade: colorShade,
      isThemeColor: isThemeColor,
      isLight: isLightColor(colorValue, theme.luminanceThreshold),
      variable: shade ? "--mantine-color-".concat(_color, "-").concat(colorShade) : "--mantine-color-".concat(_color, "-filled")
    };
  }
  return {
    color: color,
    value: color,
    isThemeColor: isThemeColor,
    isLight: isLightColor(color, theme.luminanceThreshold),
    shade: colorShade,
    variable: void 0
  };
}
export { parseThemeColor };